import config from '@/services/config'
import axios from 'axios'

const servicioBase = axios.create( {
    baseURL: config.apiUrl
})
    servicioBase.interceptors.request.use (
        config => {
                const accessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJpTWVnJCRwYSZzIiwiaWQiOiIxIiwidXNlciI6ImlNZWckJHBhJnMiLCJuYW1lIjoiMCVqYXBhJCQiLCJqdGkiOiJiODZmMDc1OS01NjA3LTQ3MGQtOGQ1YS1lN2NhNDczMjIyNDUiLCJpYXQiOjE3NzY5NDM2OTEsImV4cCI6MTgwODA3Mjg5MSwibmJmIjoxNzc2OTY4ODkxLCJpc3MiOiJodHRwOi8vd3d3Lndhcm1wYWNrLmNvbSIsImF1ZCI6IlBhZ2luYSB3ZWIifQ.430Y-oB9hmU6PPgMThutuBmCKMghwizx2It2Zp9ELgE'
                config.headers.Authorization = `Bearer ${ accessToken }`
                return config
            
        }
    )
export default servicioBase;